import request from './request'

export default class FormioApi {

  async getForm(model) {
    delete model.version
    return await request(
      {
        environment: '/formio',
        type: 'query',
        name: 'getForm',
        variables: model,
        way: './graphql/formio/',
        has_catch: true
      }
    )
  }
  async callCustomEvent(model) {
    return await request({
      environment: '/formio',
      type: 'mutation',
      name: 'callCustomEvent',
      variables: model,
      way: './graphql/formio/',
    })
  }
  async formSubmission(model) {
    return await request({
      environment: '/formio',
      type: 'mutation',
      name: 'formSubmission',
      variables: model,
      way: './graphql/formio/',
    })
  }
}
